var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "url(#pattern0_104_136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_104_136",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_104_136",
    transform: "scale(0.00555556)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_104_136",
    width: 180,
    height: 180,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAC0CAMAAAAKE/YAAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAAGUExURf///wAAAFXC034AAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH6AsWBB0CIgqv8QAAAlFJREFUeNrtm8GuwjAMBHn//9PvhISqxjuOUy7MXkC0tFMkY3udvF5KKaWUUkqpY/or9Hn8ev77/fX1ev7n9zr3FVroCXT1efUwd+eujnXvK7TQU+gV1F0A3QXo6li6bvVjCC30E9AkwVSJgwSt0EJ/E7q6Yfe40EJ/E7r6fBWIVYLpFFXHqzyhfx46NbZPvT7ajQv9s9DU70sJgRg1R6GEFhokl44RWRVDlVlZJZ0tA1JooUGiSQ0saRburkUS2/bQSGihQzOaYKoEkwoiYlAKLfQEmn5pFYBVgO4MQIUWegpNL1AV/WmwRBOP0EJPobuJpQpCYtRXRdm4uRVa6EaTSR6EFFmkCBNa6Cl0+rNPxT1JDMnIaTe2QgvdCMRkyNAiqCq8UmEltNC70GTBCB3GUxOoKryEFnoKTYKHJg26UDxtlBBa6Cl0p/GkTWtn4CS00Cehd5ICGdp3FrqMF64ILXQxrKEJoxuUxKgXWugT0F2DJjWoHfOcbHwQWugpdAq0jlFZJZUjWVFooUETkIb7ZMErCdxOYAstdBc6FfvEAKcLVrZBhRZ6owlIBnoybtJDpoWG4xWQQgsdgowYhOlYSibjQZHQQgdoakR2CiKyGWJr94XQQm+a7J0NN9SAHwej0EJDU50EBjXNqwW2dOOD0ELvQNNhJS34uwlpZNYILXQw07sNLn0okoTai76FFvoQdDLVuwG53bkILfQGdBoc0aaYDvCFFvoUNBkgrQp+eg3aLAst9BQ6NbZpkSFtCHauIbTQ0z0BSimllFJKqaX+ARC8LCELZPKuAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI0LTExLTIyVDA0OjI5OjAyKzAwOjAwQnsS/AAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNC0xMS0yMlQwNDoyOTowMiswMDowMDMmqkAAAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjQtMTEtMjJUMDQ6Mjk6MDIrMDA6MDBkM4ufAAAAIXRFWHRTb2Z0d2FyZQBPbmxpbmUgQmFyY29kZSBHZW5lcmF0b3JDAGhxAAAAMXRFWHRTb3VyY2UAaHR0cHM6Ly90aGUtYnVydG9ucy54eXovYmFyY29kZS1nZW5lcmF0b3IvS/UwFQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.d748c49897c618cd020ca06eb38daf52.svg";
export { ForwardRef as ReactComponent };